export const BREADCRUMB_BASE_SEGMENT = {
  title: 'All',
  href: '/',
};

export const BREADCRUMB_SKELETON_SEGMENT = {
  title: '',
  href: '',
  isSkeleton: true,
};
